import { Modal } from "PFComponents/modal";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

type UnsavedEditsModalProps = {
  onSaveAndContinue: () => void;
  onCancel: () => void;
};

export const UnsavedEditsModal = ({ onSaveAndContinue, onCancel }: UnsavedEditsModalProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "manageRoles" });
  const { t: tTranslation } = useTranslation();

  return (
    <Modal
      title={t("unsavedEditsModal.title")}
      labelOK={t("saveAndContinue")}
      labelCancel={tTranslation("cancel")}
      onOK={onSaveAndContinue}
      onCancel={onCancel}
      onClose={onCancel}
    >
      <Typography variant="bodyRegular">{t("unsavedEditsModal.message")}</Typography>
    </Modal>
  );
};
